import styled from 'styled-components';

export const CampusIntroBlock = styled.div`
  padding: 72px 0;
  padding-bottom: 30px;
  @media (max-width: 767px) {
    padding: 30px 0;
  }
`;

export const BlockContent = styled.div`
  @media (max-width: 767px) {
    margin-bottom: 30px;
  }

  h3 {
    margin-bottom: 35px;
    font-size: 20px;
    line-height: 30px;
    color: #000;
    font-family: ${({ dir }) => (dir === 'rtl' ? 'GEAwtarDWTCMedium,serif!important' : '')};

    @media (max-width: 767px) {
      font-size: ${({ dir }) => (dir === 'rtl' ? '20px !important' : '18px !important')};
      line-height: normal !important;
      margin-bottom: 0px;
    }
  }

  p {
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 0;
    color: #898989;
  }
`;

export const CampusBlock = styled.div`
  padding-top: 0;
  padding-bottom: 0px;

  div[class*='FilterTabBlockstyled__ToggleTag-'] {
    bottom: 150px;
    transition: all 0.3s ease-in-out 0s;

    &.open {
      bottom: calc(100% - 100px);

      @media (max-width: 767.98px) {
        bottom: calc(100% - 90px);
      }
    }

    @media (max-width: 767.98px) {
      bottom: 70px;
    }

    @media (max-width: 575px) {
      bottom: 70px;
    }
  }

  @media (max-width: 991px) {
    div[class*='Columnstyled__ColumnTwo-'] {
      justify-content: center;
    }
  }
`;
